/**
 *  @class
 *  @function ImageWithText
 *  Stamps the deferred <template class="background-video__deferred"> into the
 *  DOM when the section nears the viewport, then plays the video. Mirrors the
 *  pattern used by <background-video> and <slide-show>, but scoped to this
 *  section so theme-editor section reloads pick it up via connectedCallback.
 */
if (!customElements.get('image-with-text')) {
  class ImageWithText extends HTMLElement {
    connectedCallback() {
      this.video_container = this.querySelector('.image-with-text__image-media');
      if (!this.video_container) return;

      const template = this.video_container.querySelector('.background-video__deferred');
      if (!template) return;

      this.template = template;
      this.injected = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!this.injected) {
              // 第一次进入视口：注入 DOM（懒加载）
              if (!entry.isIntersecting) return;
              this.inject();
              return;
            }
            // 已注入：进入视口播放，离开视口暂停
            if (entry.isIntersecting) {
              this.videoPlay();
            } else {
              this.videoPause();
            }
          });
        },
        {
          rootMargin: '100px',
          // 已注入后需要能感知“离开视口”，所以不能用 0 之外过高的阈值
          threshold: 0,
        }
      );

      this.observer.observe(this);
    }

    inject() {
      this.observer.disconnect();
      this.injected = true;

      const clone = this.template.content.cloneNode(true);
      this.template.replaceWith(clone);

      const iframe = this.video_container.querySelector('iframe');
      if (iframe) {
        iframe.onload = () => this.videoPlay();
      } else if (this.video_container.querySelector('video')) {
        this.videoPlay();
      }

      // 重新观察，这次用于播放/暂停
      this.observer.observe(this);
    }

    videoPlay() {
      setTimeout(() => {
        const provider = this.video_container.dataset.provider;
        const iframe = this.video_container.querySelector('iframe');
        const video = this.video_container.querySelector('video');

        if (provider === 'youtube' && iframe) {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'playVideo',
              args: '',
            }),
            '*'
          );
        } else if (provider === 'vimeo' && iframe) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        } else if (provider === 'hosted' && video) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        }
      }, 10);
    }

    videoPause() {
      const provider = this.video_container.dataset.provider;
      const iframe = this.video_container.querySelector('iframe');
      const video = this.video_container.querySelector('video');

      if (provider === 'youtube' && iframe) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: '',
          }),
          '*'
        );
      } else if (provider === 'vimeo' && iframe) {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      } else if (provider === 'hosted' && video) {
        video.pause();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  customElements.define('image-with-text', ImageWithText);
}